module.exports = __webpack_public_path__ + "img/photo-of-sofa-near-wooden-table-3264489.e0b9dc2f.jpg";